// extracted by mini-css-extract-plugin
export default {"unstyled":"styles-module__unstyled__src-labstep-web-components-File-Action-Download-_xn3bB styles-module__unstyled__src-labstep-web-core-Link-_rOSO_"};